import {selectMessages} from '../../components/selectMessages'
import {useDispatch, useSelector} from 'react-redux'
import { IBaseOption, IClassroom, reduxProps } from "../../constants";
import {OrganizationTypeEnum} from '../../constants'
import Select from '../../components/EducationSelect'
import React, {useMemo} from 'react'
import {UiIcon} from '../../components/UiIcon'
import './DashboardHeader.scss'
import {
  actionGetStaffClassrooms,
  actionPatchClassroomCurriculum,
  actionSaveSelectedClass
} from "../../redux/education";
import {toast} from 'react-toastify'

export function ClassDashboardHeader() {
  const dispatch = useDispatch()
  const {classroom, curriculums} = useSelector((state: reduxProps) => state.educationReducer)
  const {staffInfo} = useSelector((state: reduxProps) => state.authReducer)
  const curriculumDropdown = useMemo<IBaseOption[]>(() => [...curriculums]
    .sort((a, b) => Number(a.id) - Number(b.id))
    .map(item => ({value: item.id, label: item.title})), [curriculums])

  function dropdownChange(item: any, event: any) {
    if (classroom && item.value) {
      dispatch(
        actionPatchClassroomCurriculum(
          {
            classroomId: classroom.id,
            curriculumId: item.value,
          },
          (r) => {
            if (r.type === 'SUCCESS') {
              toast('Sınıf kitaplığı değiştirildi', {type: 'success'})
              dispatch(actionGetStaffClassrooms({userId:staffInfo.id},(r)=>{
                dispatch(actionSaveSelectedClass(r.payload.data.find((classroomItem:IClassroom)=>classroomItem.id === classroom.id)))
              }))
            }
          }
        )
      )
    }
  }

  if (staffInfo.organizationTypeId === OrganizationTypeEnum.B2bCustomer) {
    return <></>
  } else {
    return (
      <section className='dashboard-class-context' aria-label='Sınıf bilgileri'>
        <div className='dashboard-class-level'>
          <span className='dashboard-context-icon'><UiIcon name='people' size={22}/></span>
          <div><span>Sınıf seviyesi</span><strong>{classroom.gradeLevelId ? `${classroom.gradeLevelId}. Sınıf` : 'Belirtilmemiş'}</strong></div>
        </div>
        <div className='dashboard-class-library'>
          <label htmlFor='dashboard-library'><UiIcon name='book' size={16}/> Sınıf kitaplığı</label>
          <Select {...selectMessages}
            inputId='dashboard-library'
            className='kidly-select'
            classNamePrefix='kidly'
            name='classroomId'
            options={curriculumDropdown}
            onChange={dropdownChange}
            value={curriculumDropdown.find((item) => item.value === classroom.curriculumId) || null}
            placeholder='Sınıf kitaplığı seçin'
            menuPlacement='auto'
          />
        </div>
      </section>
    )
  }
}
